import { render, staticRenderFns } from "./CusInfo.vue?vue&type=template&id=c6ee5c52&scoped=true"
import script from "./CusInfo.vue?vue&type=script&lang=js"
export * from "./CusInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6ee5c52",
  null
  
)

export default component.exports